import { ACCESS_IS_MOBILE } from '../actions/actionTypes'

const mobile = (state = {}, action) => {
    switch (action.type) {
        case ACCESS_IS_MOBILE:
            return {
                ...state,
                mobileActive: action.mobileActive
            }
        default:
            return state;
    }
}

export default mobile


// WEBPACK FOOTER //
// ./src/reducers/mobileReducer.js